import { Injectable, ɵConsole } from '@angular/core';
import { Storage } from '@ionic/storage';
import * as Constants from '../../app/app.constants';
import { delay } from 'q';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { CacheService } from 'ionic-cache';
import { ElencoPreferiti } from '../models/elenco-preferiti';
import { Preferito } from '../models/preferito';
import { Evento } from '../models/evento';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FavouriteService {
  intervalHandle: any = null;

  constructor(
    private storage: Storage,
    private translateService: TranslateService,
    private httpClient: HttpClient,
    private cache: CacheService
  ) {
  }

  getAllFavorite() {
    return this.storage.get(Constants.STORAGE_KEY);
  }

  isFavorite(id: string, type: string) {
    return this.getAllFavorite().then(result => {
      let trovato =
        result && result.findIndex(x => x.id === id && x.type === type) !== -1;
      return trovato;
    });
  }

  setFavorite(id: string, type: string, idFavorite: string) {
    return this.getAllFavorite().then(result => {
      if (result) {
        let favourite = result.find(x => x.id === id && x.type === type);

        if (favourite) {
          favourite.idFavorite = idFavorite;
          this.storage.set(Constants.STORAGE_KEY, result);
        } else {
          this.favorite(id, type, idFavorite);
        }
      } else {
        this.favorite(id, type, idFavorite);
      }
    });
  }

  favorite(id: string, type: string, idFavorite?: string) {
    let preferito = {
      id: id,
      type: type,
      idFavorite: idFavorite
    };
    return this.getAllFavorite().then(result => {
      if (result) {



        const index = result.findIndex(
          x => x.id === preferito.id && x.type === preferito.type
        );

        if (index === -1) {
          result.push(preferito);
          return this.storage.set(Constants.STORAGE_KEY, result).then(res => {
            //console.log('SYNC - FAV - Elenco preferiti - Aggiunto Storage Locale - Lista - Numero attuale:' + res.length);
            //console.log( res );
          });
        } else {
          console.error('SYNC - Attenzione, ho provato ad aggiungere un duplicato');
          console.log(result);
        }
      } else {
        return this.storage.set(Constants.STORAGE_KEY, [preferito]).then( res => {
          //console.log('SYNC - FAV - Elenco preferiti - Aggiunto Storage Locale - Unico - Numero attuale:' + res.length);
          //console.log( res );
        });
      }
    });
  }

  unfavorite(id: string, type: string) {
    return this.getAllFavorite().then(result => {

      if (result) {
        const index = result.findIndex(x => x.id === id && x.type === type);


        if (result[index] && result[index].idFavorite) {
          //console.log('SYNC - Elemento presente nel db - deve essere rimosso');

          let idFavoriteToRemove = result[index].idFavorite;

          //Se l'item ha idFavourite allora dovrà anche essere rimosso dal DB
          if (idFavoriteToRemove) {

            this.storage
              .get(Constants.STORAGE_KEY_TOREMOVE)
              .then((resultToRemove: any) => {
                let listToRemove = [];

                if (resultToRemove && resultToRemove.length > 0) {

                  //console.log('SYNC - Elenco di elementi che sono in attesa di essere eliminati');
                  //console.log(resultToRemove.length);
           

                  if (!Array.isArray(resultToRemove)) {
                    resultToRemove = resultToRemove.toString().split('');
                  }
                  listToRemove = resultToRemove;
                  if (resultToRemove.indexOf(idFavoriteToRemove) === -1) {
                    listToRemove.push(idFavoriteToRemove);
                  }

                } else {
                  //console.log('SYNC - La lista STORAGE_KEY_TOREMOVE era vuota');
                  listToRemove.push(idFavoriteToRemove);
                }

                this.storage.set(Constants.STORAGE_KEY_TOREMOVE, listToRemove);
              });
          }
        } else {
          //console.log('SYNC - Elemento non ancora aggiunto al DB');
        }

        //Rimozione dell'elemento dalla lista
        if ( result[index] ) {
          result.splice(index,1);
        }
        this.storage.set(Constants.STORAGE_KEY, result);

      }
    });
  }

  async aggiungiAiFavoriti(element: any) {
    if (element.isFavourite) {
      await this.unfavorite(element.id, element.typeElement.key);
    } else {
      await this.favorite(element.id, element.typeElement.key);
    }
  }

  loadFromCache(path) {
    this.cache.enableCache(true);

    //this.cache.setDefaultTTL(60 * Constants.TTL_FAVORITE);
    this.cache.setDefaultTTL(0);

    let headers = new HttpHeaders();
    headers = headers.append(
      'Accept-Language',
      this.translateService.currentLang
    );
    const options = { headers: headers };
    const cacheKey = path + '&' + this.translateService.currentLang;
    const request = this.httpClient.get(path, options);
    return this.cache.loadFromObservable(cacheKey, request);
  }



  async favoritesFromDBtoStorage(idUser, page?, size?) {
    //Prima devo eliminare sul DB quelli che ho segnato nello storage come DAELIMINARE
    await this.storage.get(Constants.STORAGE_KEY_TOREMOVE).then(async result => {
      if (result) {
        for (let item of result) {
          console.log(item);
          await this.deleteFavoriteFromDbById(item).then(res => {
            const index = result.findIndex(x => x === item);
            result.splice(index, 1);
            this.storage.set(Constants.STORAGE_KEY_TOREMOVE, result);
          });
        }
      } else {

      }
    });


    //prendo i preferiti dal DB che potrebbero non essere presenti
    //nello storage perchè inseriti da un altro dispositivo
    let elencoPreferitiSulDB: ElencoPreferiti;
    this.getFavoritesFromDb(idUser, page, size).then(
      async (res: ElencoPreferiti) => {
        elencoPreferitiSulDB = res;

        if (elencoPreferitiSulDB && elencoPreferitiSulDB.elenco) {
          const result = [];
          for (const preferito of elencoPreferitiSulDB.elenco) {

            if ( !preferito.typeElement ) {
              //Rimuovo il preferito che ha un problema
              this.deleteFavoriteFromDbById(preferito.id);
              console.error('FavouriteService - Rimosso il preferito che era salvato in modo errato');
              continue;
            }

            let id = preferito.idPoi;
            let type = preferito.typeElement.key;
            let idFavourite = preferito.id;

            const preferitoItem = {
              id: id,
              type: type,
              idFavorite: idFavourite
            };

            result.push(preferitoItem);
          }
          this.storage.set(Constants.STORAGE_KEY, result);
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  getFavoritesFromDb(idUser, page?, size?) {
    return new Promise((resolve, reject) => {
      const path = `${Constants.API_BASE_URL}${Constants.BASE_FAVORITE_URL}${Constants.USER_URL}?landId=${environment.api.tenantId}&page=${page}&size=${size}&idUser=${idUser}&timestamp=` + new Date();


      this.loadFromCache(path).subscribe(
        async (res: any) => {
          const elencoPreferiti = new ElencoPreferiti();
          elencoPreferiti.elenco = res.content;
          elencoPreferiti.page = res.number;
          elencoPreferiti.size = res.size;
          elencoPreferiti.maximumPages = res.totalPages;
          elencoPreferiti.totalElements = res.totalElements;

          resolve(elencoPreferiti);
        },
        err => {
          console.error('Lista vuota');
          reject(new ElencoPreferiti());
        }
      );
    });
  }

  getFavouriteById(id: string) {
    return new Promise((resolve, reject) => {
      const path = `${Constants.API_BASE_URL}${Constants.BASE_FAVORITE_URL}${Constants.USER_URL}${id}?landId=${environment.api.tenantId}`;
      this.loadFromCache(path).subscribe(
        async (res: any) => {
          resolve(res);
        },
        err => {
          console.error('Lista vuota');

          reject(new Preferito());
        }
      );
    });
  }

  emptyFavouriteStorage(){
    this.storage.set(Constants.STORAGE_KEY, null);
    this.storage.set(Constants.STORAGE_KEY_TOREMOVE, null);
  }

  addFavoriteToDb(preferito: Preferito) {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const path = `${Constants.API_BASE_URL}${Constants.BASE_FAVORITE_URL}${Constants.USER_URL}/?landId=${environment.api.tenantId}`;

    return this.httpClient.post(path, JSON.stringify(preferito), {
      headers: headers
    });
  }

  deleteFavoriteFromDbById(idFavoriteToRemove: string) {
    return new Promise((resolve, reject) => {
      const favoriteToRemove: Preferito = new Preferito();
      favoriteToRemove.id = idFavoriteToRemove;
      const seq = this.deleteFavoriteFromDb(favoriteToRemove);
      seq.subscribe(
        result => {
          console.log(`SYNC - Ho eliminato ${favoriteToRemove}  preferito dal db`);
          resolve();
        },
        err => {
          console.log('SYNC - qualcosa è andato storto durante l eliminazione dal db');
          resolve();
        }
      );
    });
  }

  deleteFavoriteFromDb(preferito: Preferito) {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    let path = `${Constants.API_BASE_URL}${Constants.BASE_FAVORITE_URL}${Constants.USER_URL}${
      preferito.id
    }?landId=${environment.api.tenantId}`;
    //console.log('path eliminazione ' + path);
    return this.httpClient.delete(path, { headers: headers });
  }
}
